

















































import Vue from "vue";
import ExpandibleButton from "./ExpandibleToolButton.vue";

export default Vue.extend({
  name: "ColorButton",
  components: {
    ExpandibleButton
  },
  data: () => ({
    color: "000000FF",
    defaultColors: {
      "teal": "009688FF",
      "red": "F6695EFF",
      "amber": "FFCD36FF"
    }
  }),
  methods: {
    setColor: function(value: string) {
      this.color = value;
    }
  },
  watch: {
    color: function(val) {
      this.$store.commit('setActiveToolColor', val)
    }
  }
});
